export { useResetIconStyle as default } from '../../theme/internal';
